<template>
  <div class="edit-cell">
    <div v-if="!editMode && !showInput">
      <slot name="content">{{ formattedValue }}</slot>
    </div>
    <el-date-picker
      v-if="editMode || showInput"
      ref="input"
      
      v-on="listeners"
      v-bind="$attrs"
      @change="onInputExit"
      v-model="model"
      :type="dateType"
      :format="format"
      :value-format="valueFormat"
    >
    </el-date-picker>
  </div>
</template>
<script>
import { DatePicker } from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
  },
  name: "editable-date-cell",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Date, Number],
      default: "",
    },
    toolTipContent: {
      type: String,
      default: "Click to edit",
    },
    toolTipDelay: {
      type: Number,
      default: 500,
    },
    toolTipPlacement: {
      type: String,
      default: "top-start",
    },
    showInput: {
      type: Boolean,
      default: false,
    },
    closeEvent: {
      type: String,
      default: "blur",
    },
    dateType: {
      type: String,
      default: "date",
    },
    format: {
      type: String,
      default: "MM/dd/yyyy",
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd",
    },
  },
  data() {
    return {
      editMode: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    listeners() {
      return {
        [this.closeEvent]: this.onInputExit,
        ...this.$listeners,
      };
    },
     formattedValue() {
                if (!this.value) return "";

                try {
                  const date = new Date(this.value);
                  if (isNaN(date.getTime())) return this.value;

                  // Simple format conversion
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const day = String(date.getDate()).padStart(2,"0");
                  const year = date.getFullYear();

                  // Get month name for formats that need it
                  const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"];
                  const monthName = monthNames[date.getMonth()];

                  if (this.format === "MM/dd/yyyy") {
                   return `${month}/${day}/${year}`;
                 } else if (this.format === "yyyy-MM-dd") {
                   return `${year}-${month}-${day}`;
                 } else if (this.format === "dd/MM/yyyy") {
                   return `${day}/${month}/${year}`;
                 } else if (this.format === "DD-MMMM-YYYY" || this.format === "dd-MMMM-yyyy") {
                   return `${day}-${monthName}-${year}`;
                 }

                 // Fallback to default format
                 return `${month}/${day}/${year}`;
               } catch (e) {
                 return this.value;
               }
             },
        
  },
  methods: {
    onFieldClick() {
      this.editMode = true;
      this.$nextTick(() => {
        let inputRef = this.$refs.input;
        if (inputRef) {
          inputRef.focus();
        }
      });
    },
    onInputExit() {
      this.editMode = false;
    },
    onInputChange(val) {
      this.$emit("input", val);
    },
  },
};
</script>
<style>


.edit-cell >>> .el-date-editor {
  font-size: 12px;
}

.edit-cell >>> .el-date-editor .el-input__inner {
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}


.el-input__icon .el-icon-date{
  display: flex !important;
  align-items: center !important;
}

</style>
